import { Button } from 'antd';
import { IoEyeOutline } from 'react-icons/io5';
import { LuFileText } from 'react-icons/lu';
import type { PriorStudyVM } from '../types';
import { formatPriorStudyDate } from '../utils/formatPriorStudy';
import styles from './PriorStudies.module.css';

interface PriorStudyRowProps {
  study: PriorStudyVM;
  variant: 'inline' | 'dropdown';
}

export default function PriorStudyRow({ study, variant }: PriorStudyRowProps) {
  const label = `${study.typeLabel} — ${formatPriorStudyDate(study.dateISO)}`;

  return (
    <div className={styles[variant === 'inline' ? 'inlineRow' : 'dropdownRow']}>
      <span className={styles.label}>{label}</span>
      <div className={styles.actions}>
        {study.reportUuid && (
          <Button
            size="small"
            href={`/reports/${study.uuid}/preview`}
            target="_blank"
            rel="noopener noreferrer"
            icon={<LuFileText />}
          >
            Report
          </Button>
        )}
        <Button
          size="small"
          href={`/studies/${study.uuid}`}
          target="_blank"
          rel="noopener noreferrer"
          icon={<IoEyeOutline />}
        >
          Reader
        </Button>
      </div>
    </div>
  );
}
